
import { useState } from "react";
import { AutoComplete, Button, Form, Image, Input, Select, Space, Upload, message } from "antd";
import TenantApi from "../../../../api/TenantApi";
import { CreateTenantWizardWrapper, FormWrapper, OperationWrapper, Title, TitleBar } from "./CreateTenantWizard.styled";
import Industry from "../../../../dict/Industry";
import FileApi from "../../../../api/FileApi";
import { PlusOutlined } from "@ant-design/icons";
import StringUtils from "../../../../util/StringUtils";

interface CreateTenantWizardProps {
    onClose: ()=> void,
    onComplete: ()=> void
}

const CreateTenantWizard: React.FC<CreateTenantWizardProps> = (props)=> {
    // api
    let tenantApi = new TenantApi();
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    // state
    let [step, setStep] = useState(0);
    let [createTenantParameters, setCreateTenantParameters] = useState(new CreateTenantParameters());
    let [logoUploadFileList, setLogoUploadFileList] = useState<any[]>([]);
    let [openPreview, setOpenPreview] = useState(false);

    // options
    let industries = Industry.RECORDS.map(e=> {
        return {
            id: e.ID,
            name: e.CODE,
        }
    });
    let industryOptions = industries.map((industry)=> {
        return {
            label: industry.name,
            value: industry.name,
        }
    });


    // events
    let onSubmit = async ()=> {
        await tenantApi.create(createTenantParameters);
        console.log("Create tenant successfully");
        messageApi.open({
            type: 'success',
            content: '创建租户成功',
        });
        props.onComplete();
        props.onClose();
    }

    let onCancel = ()=> {
        props.onClose();
    };

    let onPreview = (file)=> {
        setOpenPreview(true);
    };

    let onRemove = (file)=> {
        logoUploadFileList = [];
        setLogoUploadFileList([]);
        return true;
    };


    let onUpload = (file: any)=> {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            let base64DataUrl = reader.result as string;
            createTenantParameters.avatar = base64DataUrl;
            setCreateTenantParameters({...createTenantParameters});

            let logoUploadFile = {
                uid: file.uid,
                name: file.name,
                status: 'done',
                url: base64DataUrl,
            };
            logoUploadFileList = [logoUploadFile];
            setLogoUploadFileList(logoUploadFileList);
        }
        return false;
    };
 
    let onNameChange = (e)=> {
        createTenantParameters.name = e.target.value;
        setCreateTenantParameters({...createTenantParameters});
        validateForm();
    };

    let onTenantNoChange = (e)=> {
        createTenantParameters.tenantNo = e.target.value;
        setCreateTenantParameters({...createTenantParameters});
        validateForm();
    };

    let onAddressChange = (e)=> {
        createTenantParameters.address = e.target.value;
        setCreateTenantParameters({...createTenantParameters});
        validateForm();
    };

    let onIndustryChange = (industry: string)=> {
        createTenantParameters.industry = industry;
        setCreateTenantParameters({...createTenantParameters});
        validateForm();
    };

    let onRemarksChange = (e)=> {
        createTenantParameters.remarks = e.target.remarks;
        setCreateTenantParameters({...createTenantParameters});
        validateForm();
    };

    let validateForm = ()=> {

    };

    // render
    return (
        <CreateTenantWizardWrapper>
            {contextHolder}
            <TitleBar>
                <Title>创建租户</Title>
            </TitleBar>

            <FormWrapper>
                <Form form={form} name="form" layout="vertical">
                    <Form.Item name="logo" label="LOGO" rules={[{required: true}]}>
                        <Upload
                            action={FileApi.UPLOAD_URL}
                            listType="picture-circle"
                            fileList={logoUploadFileList}
                            onPreview={onPreview}
                            onRemove={onRemove}
                            beforeUpload={onUpload}
                        >
                            {
                                logoUploadFileList.length <=0 && 
                                <button style={{ border: 0, background: 'none' }} type="button">
                                    <PlusOutlined />
                                    <div style={{ marginTop: 8 }}>Upload</div>
                                </button>
                            }
                        </Upload>

                        <Image
                            wrapperStyle={{ display: 'none' }}
                            src={logoUploadFileList[0]?.url}
                            preview={{
                                visible: openPreview,
                                onVisibleChange: (visible) => setOpenPreview(visible),
                                afterOpenChange: (visible) => !visible && setOpenPreview(false),
                            }}
                        />
                    </Form.Item>

                    <Form.Item name="name" label="租户名称" rules={[{required: true}]}>
                        <Input onChange={onNameChange} />
                    </Form.Item>

                    <Form.Item name="tenantNo" label="租户编号" rules={[{required: true}]}>
                        <Input onChange={onTenantNoChange} />
                    </Form.Item>

                    <Form.Item name="address" label="地址" rules={[{required: true}]}>
                        <Input onChange={onAddressChange} />
                    </Form.Item>

                    <Form.Item name="industry" label="行业" rules={[{required: true}]}>
                        <AutoComplete
                            options={industryOptions}
                            placeholder="请输入行业"
                            filterOption={(inputValue, option) =>
                                StringUtils.nonull(option.value).toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                || StringUtils.nonull(option.label).toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                            onChange={onIndustryChange}
                        />
                    </Form.Item>

                    <Form.Item name="remarks" label="备注" rules={[{required: false}]}>
                        <Input.TextArea style={{height: '100px'}} onChange={onRemarksChange}/>
                    </Form.Item>
                </Form>
            </FormWrapper>

            <OperationWrapper>
                <Space size="middle">
                    <Button type="primary" onClick={onSubmit}>创建</Button>
                    <Button type="primary" danger onClick={onCancel}>取消</Button>
                </Space>
            </OperationWrapper>
        </CreateTenantWizardWrapper>
    )
}

class CreateTenantParameters {
    // targeted device template
    name: string;
    avatar: string;
    tenantNo: string;
    address: string;
    industry: string;
    remarks: string;
}

export default CreateTenantWizard;
